define('model/template.type.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var TemplateType = BaseModel.extend(
    {
      radioRequests: {
        'models TemplateType': '@constructor',
        'models TemplateTypeModel': '@constructor',
      },

      urlRoot: '/api/v1/eform/templateType',
    },
    {}
  );
  module.exports = TemplateType;
});

